/**
 *@author: Sirisha.M
 *@Description : This component is mainly for showing list of created questions
 **/
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {  Input, Button, message, Tooltip } from 'antd';
import { connect } from 'react-redux';
import { PlusOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import localStorage from '../../utils/localStorage';
import StyledTable from '../../commons/styles/table';
import { API_FRACAS } from '../../commons/api';
import './style.css';

const QuestionsList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  // const [searchedColumn, setSearchedColumn] = useState('');

  const hRef = useRef(null);
  const rRef = useRef(null);
//   const navigate = useNavigate();
  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = await getList();
        setDataSource(data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const getList = async () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'GET',
      url: `${API_FRACAS.QuestionsGet}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.info(err && err.response && err.response.data && err.response.data.message);
      });
  };
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),

    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    // setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const addNew = () => {
    props.navigate('/rubus/FRACAS/QuestionsDetails/New');
  };
  const editRecord = (record) => {
    props.navigate(
      `/rubus/FRACAS/QuestionsDetails/${record.Id}?DeviceTypeCode=${record.DeviceTypeCode}&FailureTypeId=${record.FailureTypeId}`
    );
  };
  const columns = [
    {
      title: translation('Device Type'),
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation('Failure Type'),
      dataIndex: 'FailureTypeName',
      key: 'FailureTypeName'
    },
    {
      title: translation('Actions'),
      width: '600',
      render: (text, record) => (
        <>
          <Button type="primary" onClick={() => editRecord(record)}>
            <Tooltip title={translation('Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];
  return (
    <div style={{ minHeight: window.innerHeight - 69, paddingLeft: '40px', paddingRight: '40px' }}>
      <Button
        type="primary"
        onClick={addNew}
        style={{
          background: '#214972',
          marginBottom: '10px',
          float: 'right',
          marginTop: '5px'
        }}
      >
        <PlusOutlined /> Add
      </Button>
      <StyledTable size="small"
        columns={columns}
        dataSource={dataSource}
        style={{ marginTop: '24px' }}
        // pagination={
        //   dataSource.length > 10
        //     ? {
        //       pageSize: '10',
        //     }
        //     : false
        // }
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(QuestionsList);